import {
  Button,
  InlineStack,
  Text,
  TextField
} from '@shopify/polaris';
import { useCallback, useEffect, useState } from 'react';

import {
  EditIcon
} from '@shopify/polaris-icons';

interface TitleEditorProps {
  editAcive?: boolean;
  value?: string;
  onChange: (value: string) => void;
}

export default function TitleEditor({ editAcive, value, onChange }: TitleEditorProps) {
  const [active, setActive] = useState(false)
  const [lazyValue, setLazyValue] = useState(value)


  useEffect(() => {
    if (!editAcive) setLazyValue(value)
  }, [value, editAcive])

  const activateInput = useCallback(() => {
    if (editAcive) setActive(true)
  }, [editAcive, setActive])

  const handleBlur = useCallback(() => {
    onChange(lazyValue || '')
    setActive(false)
  }, [onChange, setActive, lazyValue])

  const handleChange = useCallback(setLazyValue, [])

  if (!active) return (
    <div style={{ cursor: active ? 'pointer' : 'pointer', minHeight: "2rem", }} onClick={activateInput}>
      <InlineStack align="start" gap="200">
        {lazyValue
          ? <Text variant="headingLg" as="h1">{lazyValue}</Text>
          : <Text as="span" tone="subdued" variant="headingLg">Add title</Text>
        }
        {editAcive && <Button icon={EditIcon} variant="tertiary" />}
      </InlineStack>
    </div>
  )

  return (
    <TextField
      label="Title"
      labelHidden
      autoComplete="off"
      value={lazyValue || ''}
      focused
      placeholder="title"
      onChange={handleChange}
      onBlur={handleBlur}
    />
  )
}
